const labels = {
  All: { 'Ref: Page title': 'Leveranciers' },
  SuppliersList: {
    'Ref: Supplier details': 'Zie details',
    'Missing supplier list': 'We hebben geen leverancier gevonden.',
    'Try again later': 'Probeer het later opnieuw',
  },
  SupplierDetails: {
    'Address label': 'Adres:',
    'Website label': 'Website:',
    'Details label': 'Details',
  },
};
export default labels;
